import { render, staticRenderFns } from "./PopupRiskInfo_5x4_2.vue?vue&type=template&id=98dc9b44&scoped=true"
import script from "./PopupRiskInfo_5x4_2.vue?vue&type=script&lang=js"
export * from "./PopupRiskInfo_5x4_2.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskInfo_5x4_2.vue?vue&type=style&index=0&id=98dc9b44&prod&lang=scss&scoped=true"
import style1 from "./PopupRiskInfo_5x4_2.vue?vue&type=style&index=1&id=98dc9b44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dc9b44",
  null
  
)

export default component.exports